module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticStyle: {
      "enable-background": "new 0 0 391.3 38.3"
    },
    attrs: {
      "version": "1.1",
      "xmlns": "http://www.w3.org/2000/svg",
      "xmlns:xlink": "http://www.w3.org/1999/xlink",
      "x": "0px",
      "y": "0px",
      "viewBox": "0 0 391.3 38.3",
      "xml:space": "preserve"
    }
  }, [_c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M18.4,4.4c2.9,0,5.7,0.7,8.2,2.2c2.5,1.5,4.6,3.5,6.1,6c1.5,2.5,2.2,5.2,2.2,8.1s-0.8,5.6-2.2,8.1\n    c-1.5,2.5-3.5,4.5-6.1,6C24,36.3,21.3,37,18.4,37c-2.9,0-5.7-0.7-8.2-2.2c-2.5-1.5-4.6-3.5-6.1-6c-1.5-2.5-2.2-5.2-2.2-8.1\n    c0-2.2,0.4-4.3,1.3-6.3c0.9-2,2.1-3.7,3.6-5.3c1.5-1.5,3.3-2.7,5.3-3.5C14.1,4.8,16.2,4.4,18.4,4.4z M18.4,6.3\n    c-2.6,0-5,0.7-7.2,2c-2.2,1.3-4,3.1-5.3,5.3c-1.3,2.2-2,4.6-2,7.2s0.7,5,2,7.2c1.3,2.2,3.1,4,5.3,5.3c2.2,1.3,4.6,2,7.2,2\n    c2.6,0,5-0.7,7.2-2c2.2-1.3,4-3.1,5.3-5.3c1.3-2.2,2-4.6,2-7.2c0-1.9-0.4-3.8-1.1-5.5c-0.8-1.8-1.8-3.3-3.1-4.6s-2.9-2.4-4.6-3.1\n    C22.1,6.7,20.3,6.3,18.4,6.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M41.5,17.1v3h0.1c0.6-1.1,1.4-1.9,2.4-2.5c1-0.6,2.1-0.9,3.4-0.9c1.6,0,2.9,0.3,3.9,1c0.9,0.6,1.6,1.6,2,2.7\n    c0.4,1.2,0.6,2.7,0.6,4.4v11.8h-1.9V24.8c0-1.4-0.1-2.5-0.3-3.4c-0.2-0.9-0.7-1.6-1.3-2.2c-0.7-0.5-1.7-0.8-3-0.8\n    c-1.5,0-2.7,0.4-3.5,1.2c-0.8,0.8-1.4,1.8-1.7,3.1c-0.3,1.3-0.4,2.7-0.4,4.2v9.6h-1.9V17.1H41.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M77.2,27H60.3c0,1.6,0.3,3.1,1,4.3c0.7,1.2,1.6,2.2,2.8,2.9c1.2,0.7,2.5,1,4,1c1.5,0,2.8-0.4,4-1.2\n    c1.2-0.8,2.1-1.9,2.9-3.2l1.6,0.9c-0.9,1.7-2.1,3-3.6,3.9S69.8,37,67.8,37c-1.9,0-3.5-0.5-5-1.4c-1.4-0.9-2.5-2.2-3.3-3.7\n    c-0.8-1.6-1.2-3.3-1.2-5.1c0-1.8,0.4-3.5,1.2-5.1c0.8-1.5,1.9-2.8,3.3-3.7s3.1-1.4,4.9-1.4c1.9,0,3.6,0.5,5,1.4\n    c1.4,0.9,2.5,2.2,3.3,3.8C76.8,23.4,77.2,25.2,77.2,27z M60.3,25.3h15c-0.2-1.2-0.6-2.3-1.2-3.4c-0.7-1-1.6-1.9-2.6-2.5\n    c-1.1-0.6-2.3-0.9-3.5-0.9s-2.5,0.3-3.6,0.9c-1.1,0.6-2,1.4-2.7,2.5C60.8,22.9,60.4,24.1,60.3,25.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M90.1,36.6H82V4.8h6.4c1.5,0,2.7,0.1,3.7,0.4c1,0.2,2,0.7,2.8,1.5c1.8,1.5,2.7,3.7,2.7,6.6\n    c0,2.9-1.2,5.1-3.7,6.5c1.3,0.3,2.4,0.8,3.4,1.5c1,0.8,1.8,1.7,2.3,2.8c0.5,1.1,0.8,2.3,0.8,3.7c0,2.7-1,4.9-3,6.6\n    c-1,0.9-2.1,1.5-3.3,1.8C93.1,36.5,91.7,36.6,90.1,36.6z M84,6.7v12.5h3.5h1c1,0,1.9-0.1,2.6-0.2c0.7-0.1,1.4-0.5,2.1-1\n    c0.9-0.6,1.5-1.4,1.8-2.2c0.3-0.8,0.5-1.8,0.5-2.9c0-1.1-0.2-2.1-0.6-3c-0.4-0.9-1.1-1.7-2-2.2c-0.7-0.5-1.5-0.7-2.3-0.8\n    c-0.8-0.1-1.9-0.2-3.1-0.2H84z M84,21.1v13.6h4.8c1.5,0,2.8-0.1,3.7-0.2c1-0.1,1.9-0.5,2.8-1c2.1-1.4,3.1-3.3,3.1-5.7\n    c0-1.2-0.3-2.3-0.9-3.4c-0.6-1-1.4-1.8-2.4-2.3c-1.4-0.7-3.6-1-6.7-1H84z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M107.5,17.1v2.5h0.1c0.8-2,2.3-2.9,4.2-2.9c0.7,0,1.4,0.2,2.1,0.5l-1,1.7c-0.5-0.3-0.9-0.4-1.3-0.4\n    c-1.2,0-2,0.4-2.6,1.1c-0.6,0.7-1,1.6-1.1,2.6c-0.2,1-0.2,2.2-0.2,3.5v1v10h-1.9V17.1H107.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M134.5,17.1v19.5h-1.9v-3.5h-0.1c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1v-3.4H134.5z M124.9,18.5c-1.1,0-2.1,0.2-3,0.7\n    c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1\n    s2.5,1.2,4,1.2c1.6,0,3-0.4,4.1-1.2c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1\n    c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7C127.1,18.7,126.1,18.5,124.9,18.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M142.9,17.1v3h0.1c0.6-1.1,1.4-1.9,2.4-2.5s2.1-0.9,3.4-0.9c1.6,0,2.9,0.3,3.9,1c0.9,0.6,1.6,1.6,2,2.7\n    c0.4,1.2,0.6,2.7,0.6,4.4v11.8h-1.9V24.8c0-1.4-0.1-2.5-0.3-3.4c-0.2-0.9-0.7-1.6-1.3-2.2c-0.7-0.5-1.7-0.8-3-0.8\n    c-1.5,0-2.7,0.4-3.5,1.2c-0.8,0.8-1.4,1.8-1.7,3.1c-0.3,1.3-0.4,2.7-0.4,4.2v9.6H141V17.1H142.9z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M176.9,36.6v-3.5h-0.1c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1V1.8h1.9v34.8H176.9z M169.3,35.3c1.6,0,3-0.4,4.1-1.2\n    c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7\n    c-1-0.4-2-0.6-3.2-0.6c-1.1,0-2.1,0.2-3,0.7c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1\n    c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1S167.8,35.3,169.3,35.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M218.4,36.6L213,10.3h-0.1l-11.1,27.4l-11-27.4h-0.1l-5.4,26.3h-1.9l6.8-32.9l11.7,28.9l11.7-28.9l6.8,32.9\n    H218.4z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M242,17.1v19.5h-1.9v-3.5H240c-0.7,1.2-1.7,2.2-3.1,2.9c-1.4,0.7-2.8,1.1-4.3,1.1c-1.9,0-3.6-0.5-5.1-1.4\n    c-1.5-0.9-2.6-2.2-3.4-3.7c-0.8-1.6-1.2-3.3-1.2-5.2c0-1.4,0.2-2.8,0.7-4c0.4-1.2,1.1-2.3,1.9-3.2c0.8-0.9,1.8-1.6,3-2.1\n    c1.2-0.5,2.5-0.7,3.9-0.7c1.5,0,2.9,0.3,4.3,1c1.3,0.7,2.4,1.6,3.2,2.8h0.1v-3.4H242z M232.4,18.5c-1.1,0-2.1,0.2-3,0.7\n    c-0.9,0.5-1.7,1.1-2.4,1.8c-0.7,0.8-1.2,1.7-1.6,2.7c-0.4,1-0.6,2-0.6,3.1c0,1.5,0.3,2.9,1,4.2c0.6,1.3,1.5,2.4,2.7,3.1\n    s2.5,1.2,4,1.2c1.6,0,3-0.4,4.1-1.2c1.2-0.8,2-1.8,2.6-3.2c0.6-1.3,0.9-2.8,0.9-4.4c0-1.1-0.2-2.2-0.6-3.1\n    c-0.4-1-0.9-1.8-1.6-2.6s-1.5-1.3-2.5-1.7C234.7,18.7,233.6,18.5,232.4,18.5z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M258.3,19.8l-1.6,0.8c-0.3-0.7-0.8-1.2-1.4-1.6c-0.6-0.4-1.3-0.6-2-0.6c-0.8,0-1.6,0.3-2.3,0.9\n    c-0.7,0.6-1,1.3-1,2.1c0,1,0.3,1.7,1,2.2c0.7,0.4,1.8,0.9,3.5,1.6c1.7,0.6,2.9,1.3,3.7,2.1c0.8,0.8,1.3,2,1.3,3.6\n    c0,1.2-0.3,2.2-0.8,3.1c-0.6,0.9-1.3,1.7-2.3,2.2c-1,0.5-2,0.8-3.2,0.8c-1.6,0-3.1-0.5-4.3-1.4c-1.2-0.9-2-2.2-2.4-3.8l1.9-0.6\n    c0.8,2.6,2.4,4,4.9,4c1.2,0,2.3-0.4,3.1-1.3c0.8-0.9,1.3-1.9,1.3-3.1c0-1.1-0.3-1.9-1-2.4c-0.6-0.5-1.6-1-2.8-1.4\n    c-1.2-0.4-2.1-0.8-2.9-1.2c-0.8-0.4-1.4-0.9-2-1.6c-0.5-0.7-0.8-1.5-0.8-2.5c0-1.4,0.5-2.6,1.6-3.5c1-0.9,2.3-1.4,3.7-1.4\n    c0.7,0,1.3,0.1,2,0.4c0.7,0.3,1.3,0.6,1.8,1.1C257.7,18.7,258.1,19.2,258.3,19.8z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M266.4,18.9v17.7h-1.9V18.9h-2.2v-1.8h2.2v-7h1.9v7h3.4v1.8H266.4z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M290,27h-16.9c0,1.6,0.3,3.1,1,4.3c0.7,1.2,1.6,2.2,2.8,2.9c1.2,0.7,2.5,1,4,1c1.5,0,2.8-0.4,4-1.2\n    s2.1-1.9,2.9-3.2l1.6,0.9c-0.9,1.7-2.1,3-3.6,3.9s-3.2,1.4-5.1,1.4c-1.9,0-3.5-0.5-5-1.4c-1.4-0.9-2.5-2.2-3.3-3.7\n    c-0.8-1.6-1.2-3.3-1.2-5.1c0-1.8,0.4-3.5,1.2-5.1c0.8-1.5,1.9-2.8,3.3-3.7c1.4-0.9,3.1-1.4,4.9-1.4c1.9,0,3.6,0.5,5,1.4\n    c1.4,0.9,2.5,2.2,3.3,3.8C289.7,23.4,290,25.2,290,27z M273.1,25.3h15c-0.2-1.2-0.6-2.3-1.2-3.4c-0.7-1-1.6-1.9-2.6-2.5\n    c-1.1-0.6-2.3-0.9-3.5-0.9c-1.3,0-2.5,0.3-3.6,0.9c-1.1,0.6-2,1.4-2.7,2.5C273.6,22.9,273.2,24.1,273.1,25.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M296.5,17.1v2.5h0.1c0.8-2,2.3-2.9,4.2-2.9c0.7,0,1.4,0.2,2.1,0.5l-1,1.7c-0.5-0.3-0.9-0.4-1.3-0.4\n    c-1.2,0-2,0.4-2.6,1.1c-0.6,0.7-1,1.6-1.1,2.6c-0.2,1-0.2,2.2-0.2,3.5v1v10h-1.9V17.1H296.5z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st3",
    attrs: {
      "points": "12.3,10.2 21.4,15.4 30.6,20.6 21.5,25.9 12.4,31.3 12.3,20.7"
    }
  }), _vm._v(" "), _c('line', {
    staticClass: "st3",
    attrs: {
      "x1": "12.3",
      "y1": "13.6",
      "x2": "27.4",
      "y2": "22.5"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st4",
    attrs: {
      "points": "353.2,36 353.2,26.8 363.3,26.8 363.3,28.4 355.3,28.4 355.3,30.4 363.3,30.4 363.3,32 355.3,32 355.3,34.3 363.3,34.3 363.3,36"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st4",
    attrs: {
      "points": "349.2,33 349.2,26.8 351.3,26.8 351.3,36 349.7,36 342.2,29.7 342.2,36 340.1,36 340.1,26.8 341.7,26.8"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M375.2,36l-1.2-2.2h-5.6l-1.2,2.2h-2.1l5.1-9.3h1.9l5.1,9.3H375.2z M371.2,28.6l-2.1,3.8h4.2L371.2,28.6z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M378.9,36v-9.1h7.7c0.6,0,1,0,1.4,0.1c0.4,0.1,0.7,0.3,0.9,0.5c0.2,0.2,0.4,0.5,0.5,0.9\n    c0.1,0.4,0.1,0.8,0.1,1.4V33c0,0.6,0,1-0.1,1.4c-0.1,0.4-0.2,0.7-0.5,0.9c-0.2,0.2-0.5,0.4-0.9,0.5c-0.4,0.1-0.8,0.1-1.4,0.1\n    H378.9z M387.7,29.8c0-0.5-0.1-0.8-0.2-0.9c-0.2-0.2-0.4-0.2-0.8-0.2h-5.9v5.5h5.9c0.4,0,0.7-0.1,0.8-0.2\n    c0.2-0.2,0.2-0.5,0.2-0.9V29.8z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st4",
    attrs: {
      "d": "M326.3,28.8c0-0.9,0.2-1.5,0.5-1.9c0.3-0.3,1-0.5,1.9-0.5h7.2c0.9,0,1.6,0.2,1.9,0.5\n    c0.3,0.3,0.5,0.9,0.5,1.9V34c0,0.9-0.2,1.5-0.5,1.9c-0.3,0.3-1,0.5-1.9,0.5h-7.2c-0.9,0-1.6-0.2-1.9-0.5\n    c-0.3-0.3-0.5-0.9-0.5-1.9V28.8z M328.5,34.5h7.6v-6.3h-7.6V34.5z"
    }
  }), _vm._v(" "), _c('polygon', {
    staticClass: "st5",
    attrs: {
      "points": "331.1,31.4 331.1,29.6 332.6,30.5 334.2,31.4 332.6,32.3 331.1,33.2"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st5",
    attrs: {
      "d": "M331.1,33.5c-0.1,0-0.1,0-0.2,0c-0.1-0.1-0.2-0.2-0.2-0.3v-3.6c0-0.1,0.1-0.2,0.2-0.3\n    c0.1-0.1,0.2-0.1,0.3,0l3.1,1.8c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1-0.1,0.2-0.2,0.3l-3.1,1.8C331.2,33.5,331.1,33.5,331.1,33.5\n      M331.4,30.2v2.5l2.1-1.2L331.4,30.2z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M309.2,35.8h-1.1v-9.3h1.1v3.3c0.5-0.6,1.1-0.9,1.8-0.9c0.4,0,0.8,0.1,1.2,0.3s0.7,0.4,0.9,0.7\n    s0.4,0.7,0.6,1.1c0.1,0.4,0.2,0.9,0.2,1.4c0,1.2-0.3,2-0.9,2.7c-0.6,0.6-1.3,0.9-2.1,0.9c-0.8,0-1.4-0.3-1.9-1V35.8z\n      M309.2,32.3c0,0.8,0.1,1.4,0.3,1.8c0.4,0.6,0.8,0.9,1.5,0.9c0.5,0,0.9-0.2,1.3-0.7c0.4-0.4,0.5-1.1,0.5-1.9\n    c0-0.9-0.2-1.5-0.5-1.9c-0.3-0.4-0.8-0.6-1.3-0.6c-0.5,0-0.9,0.2-1.3,0.7C309.4,30.9,309.2,31.5,309.2,32.3z"
    }
  }), _vm._v(" "), _c('path', {
    staticClass: "st2",
    attrs: {
      "d": "M315.3,38.4l-0.1-1.1c0.2,0.1,0.5,0.1,0.7,0.1c0.3,0,0.5,0,0.6-0.1s0.3-0.2,0.4-0.4\n    c0.1-0.1,0.2-0.4,0.3-0.9c0-0.1,0.1-0.2,0.1-0.3l-2.6-6.8h1.2l1.4,3.9c0.2,0.5,0.3,1,0.5,1.6c0.1-0.5,0.3-1,0.5-1.5l1.4-3.9h1.1\n    l-2.6,6.9c-0.3,0.7-0.5,1.3-0.6,1.5c-0.2,0.4-0.4,0.7-0.7,0.8c-0.3,0.2-0.6,0.3-0.9,0.3C315.8,38.5,315.6,38.4,315.3,38.4z"
    }
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-303e4c98"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/logo.vue
// module id = 135
// module chunks = 18